import { database } from './firebase';
import { ref, push, set, onValue, update, remove } from 'firebase/database';

export class FletesService {
  static async crearFlete(flete) {
    try {
      console.log('FletesService: Creando flete...', flete);
      
      // Guardar en Realtime Database
      const fletesRef = ref(database, 'fletes');
      const nuevoFleteRef = push(fletesRef);
      const fleteConId = {
        ...flete,
        id: nuevoFleteRef.key,
        fechaCreacion: new Date().toISOString(),
        fechaActualizacion: new Date().toISOString(),
        timestamp: Date.now()
      };
      
      await set(nuevoFleteRef, fleteConId);
      console.log('FletesService: Flete creado en Realtime Database con ID:', nuevoFleteRef.key);
      
      // También guardar en localStorage como respaldo
      this.guardarEnLocalStorage(fleteConId);
      
      return fleteConId;
    } catch (error) {
      console.error('Error al crear flete en Realtime Database:', error);
      console.log('FletesService: Guardando flete en localStorage como respaldo...');
      
      // Si Firebase falla, guardar solo en localStorage
      const id = 'local_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      const fleteConId = {
        ...flete,
        id: id,
        fechaCreacion: new Date().toISOString(),
        fechaActualizacion: new Date().toISOString(),
        timestamp: Date.now()
      };
      
      this.guardarEnLocalStorage(fleteConId);
      console.log('FletesService: Flete guardado en localStorage con ID:', id);
      return fleteConId;
    }
  }

  static async actualizarFlete(fleteId, datos) {
    try {
      console.log('FletesService: Actualizando flete:', fleteId, datos);
      
      // Actualizar en Realtime Database
      const fleteRef = ref(database, `fletes/${fleteId}`);
      const datosActualizados = {
        ...datos,
        fechaActualizacion: new Date().toISOString(),
        timestamp: Date.now()
      };
      
      await update(fleteRef, datosActualizados);
      console.log('FletesService: Flete actualizado en Realtime Database');
      
      // También actualizar en localStorage
      this.actualizarEnLocalStorage(fleteId, datosActualizados);
      
      return datosActualizados;
    } catch (error) {
      console.error('Error al actualizar flete en Realtime Database:', error);
      
      // Si Firebase falla, actualizar solo en localStorage
      const datosActualizados = {
        ...datos,
        fechaActualizacion: new Date().toISOString(),
        timestamp: Date.now()
      };
      this.actualizarEnLocalStorage(fleteId, datosActualizados);
    }
  }

  static async eliminarFlete(fleteId) {
    try {
      console.log('FletesService: Eliminando flete:', fleteId);
      
      // Eliminar de Realtime Database
      const fleteRef = ref(database, `fletes/${fleteId}`);
      await remove(fleteRef);
      console.log('FletesService: Flete eliminado de Realtime Database');
      
      // También eliminar de localStorage
      this.eliminarDeLocalStorage(fleteId);
    } catch (error) {
      console.error('Error al eliminar flete en Realtime Database:', error);
      
      // Si Firebase falla, eliminar solo de localStorage
      this.eliminarDeLocalStorage(fleteId);
    }
  }

  static suscribirseFletes(callback) {
    try {
      console.log('FletesService: Iniciando suscripción a fletes...');
      
      // Primero intentar obtener datos de localStorage inmediatamente
      const fletesLocal = this.obtenerDeLocalStorage();
      console.log('FletesService: Fletes de localStorage (inicial):', fletesLocal.length);
      
      // Si hay datos en localStorage, mostrarlos inmediatamente
      if (fletesLocal.length > 0) {
        callback(fletesLocal);
      }
      
      // Conectar con Realtime Database
      const fletesRef = ref(database, 'fletes');
      return onValue(fletesRef, (snapshot) => {
        console.log('FletesService: Datos recibidos de Realtime Database:', snapshot.val());
        const fletesFirebase = [];
        
        if (snapshot.exists()) {
          snapshot.forEach((child) => {
            console.log('FletesService: Procesando flete:', child.key, child.val());
            fletesFirebase.push(child.val());
          });
        }
        
        // También obtener de localStorage y combinar
        const fletesLocalActualizados = this.obtenerDeLocalStorage();
        console.log('FletesService: Fletes de localStorage (actualizados):', fletesLocalActualizados.length);
        const fletesCombinados = [...fletesFirebase, ...fletesLocalActualizados];
        
        // Eliminar duplicados
        const fletesUnicos = fletesCombinados.filter((flete, index, self) => 
          index === self.findIndex(f => f.id === flete.id)
        );
        
        console.log('FletesService: Total fletes únicos:', fletesUnicos.length);
        callback(fletesUnicos);
      }, (error) => {
        console.error('Error en suscripción de fletes:', error);
        console.log('FletesService: Usando solo datos de localStorage...');
        
        // Si la suscripción falla, usar solo localStorage
        const fletesLocal = this.obtenerDeLocalStorage();
        console.log('FletesService: Fallback a localStorage, fletes encontrados:', fletesLocal.length);
        callback(fletesLocal);
      });
    } catch (error) {
      console.error('Error al suscribirse a fletes:', error);
      console.log('FletesService: Error crítico, usando solo localStorage...');
      
      // Si hay error, usar solo localStorage
      const fletesLocal = this.obtenerDeLocalStorage();
      console.log('FletesService: Error, usando localStorage, fletes encontrados:', fletesLocal.length);
      callback(fletesLocal);
      
      // Devolver una función de limpieza vacía
      return () => {};
    }
  }

  static guardarEnLocalStorage(flete) {
    try {
      const fletes = this.obtenerDeLocalStorage();
      fletes.push(flete);
      localStorage.setItem('fletes_backup', JSON.stringify(fletes));
      console.log('FletesService: Flete guardado en localStorage:', flete);
    } catch (error) {
      console.error('Error al guardar en localStorage:', error);
    }
  }

  static obtenerDeLocalStorage() {
    try {
      const fletes = localStorage.getItem('fletes_backup');
      return fletes ? JSON.parse(fletes) : [];
    } catch (error) {
      console.error('Error al obtener de localStorage:', error);
      return [];
    }
  }

  static actualizarEnLocalStorage(id, datos) {
    try {
      const fletes = this.obtenerDeLocalStorage();
      const index = fletes.findIndex(f => f.id === id);
      
      if (index !== -1) {
        fletes[index] = {
          ...fletes[index],
          ...datos,
          fechaActualizacion: new Date().toISOString(),
          timestamp: Date.now()
        };
        localStorage.setItem('fletes_backup', JSON.stringify(fletes));
        console.log('FletesService: Flete actualizado en localStorage:', fletes[index]);
      }
    } catch (error) {
      console.error('Error al actualizar en localStorage:', error);
    }
  }

  static eliminarDeLocalStorage(id) {
    try {
      const fletes = this.obtenerDeLocalStorage();
      const fletesFiltrados = fletes.filter(f => f.id !== id);
      localStorage.setItem('fletes_backup', JSON.stringify(fletesFiltrados));
      console.log('FletesService: Flete eliminado de localStorage:', id);
    } catch (error) {
      console.error('Error al eliminar de localStorage:', error);
    }
  }
}












